/**
 * 契約情報登録フォームのフィールド
 */
export type ContractFormFields = {
  /**
   * メニューID
   * ※本来は string だがフォームで扱う際は string とする
   */
  menuId: string;
  /** 有効/無効 */
  valid: boolean;
};

/**
 * 契約情報登録フォームのフィールドの初期値
 */
export const initContractFormFields: ContractFormFields = {
  menuId: '',
  valid: true,
};
